<template>
  <v-dialog v-model="dialogVisible" class="white" max-width="400">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="grey darken-1"
        dark
        depressed
        block
        v-bind="attrs"
        v-on="on"
        :disabled="disabled"
      >
        <v-icon>mdi-angle-acute</v-icon>
      </v-btn>
    </template>
    <v-card class="ma-0 white angle-input-dialog">
      <v-card-title>
        <p class="ma-0 pa-0">
          <span class="text-h5">
            {{ manualInputVisible ? 'Winkelauswahl' : 'Sensor' }}
          </span>
          <br />
          <span class="text-h4 angle-input-title primary--text">{{
            title
          }}</span>
        </p>
      </v-card-title>
      <DialogManualInput
        :shaft="shaftInput"
        :startAngle="originalAngle"
        :type="type"
        :title="title"
        :disabled="disabled"
        @angleChanged="onAngleChanged"
        v-if="manualInputVisible"
      />
      <DialogSensorInput
        :shaft="shaftInput"
        :startAngle="originalAngle"
        :type="type"
        :title="title"
        :disabled="disabled"
        @angleChanged="onAngleChanged"
        v-if="!manualInputVisible"
      />

      <v-card-actions>
        <v-btn
          class="grey darken-1 mb-2 d-none"
          dark
          depressed
          icon
          @click="manualInputVisible = false"
          v-if="sensorInputEnabled"
        >
          <v-icon>mdi-compass-rose</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="onCancelClick">
          Abbrechen
        </v-btn>
        <v-btn color="primary" text @click="onOkClick">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogManualInput from '@/components/DialogManualInput.vue';
import DialogSensorInput from '@/components/DialogSensorInput.vue';

export default {
  name: 'DialogAngleInput',
  components: { DialogManualInput, DialogSensorInput },
  props: ['shaft', 'startAngle', 'type', 'title', 'disabled'],
  data: () => ({
    dialogVisible: false,
    manualInputVisible: true,
    shaftInput: undefined,
    outputAngle: 0,
    originalAngle: 0,
    updateTimeout: undefined,
  }),
  computed: {
    sensorInputEnabled() {
      return window && window.DeviceOrientationEvent;
    },
  },
  watch: {
    dialogVisible() {
      this.manualInputVisible = true;
      if (this.dialogVisible) {
        this.shaftInput = undefined;
        this.originalAngle = !this.startAngle ? '0' : undefined; // reset value to ensure that watcher fires
        this.$nextTick(() => {
          this.shaftInput = this.shaft;
          this.originalAngle = this.startAngle;
        });
      }
    },
  },
  methods: {
    onAngleChanged(angle) {
      if (!this.dialogVisible) return;

      // store angle
      this.outputAngle = angle;

      // emit event after timeout
      if (this.updateTimeout) clearTimeout(this.updateTimeout);
      this.updateTimeout = setTimeout(() => {
        if (angle !== this.originalAngle) this.$emit('angleChanged', angle);
      }, 1000);
    },
    onCancelClick() {
      this.dialogVisible = false;
      if (this.updateTimeout) clearTimeout(this.updateTimeout);
      this.$emit('angleChanged', this.originalAngle);
    },
    onOkClick() {
      var value = this.outputAngle;
      this.dialogVisible = false;
      if (this.updateTimeout) clearTimeout(this.updateTimeout);
      this.$emit('angleChanged', value);
    },
  },
};
</script>

<style scoped>
.angle-input-dialog {
  overflow-x: hidden;
}

.sensor-input-button {
  position: absolute;
  right: 20px;
}
</style>
